export default {
  routeName: "Admin",
  routeValue: "ADM"
};
